import src from "IMAGE";
export default { src, width: 239, height: 71, blurWidth: 0, blurHeight: 0};
